/**
 * Builds a poster URL for a given video URL.
 * @param {String} videoUrl - the URL of the video for which to build a poster URL
 * @returns {String|null} - the built poster URL or null if it cannot be built
 */
export const buildPosterUrl = (videoUrl) => {
  const prefix = window.theme?.cdn_preview_image_url_prefix;
  const suffix = window.theme?.cdn_preview_image_url_suffix;
  if (!prefix || !suffix || !videoUrl) return null;

  const videoId = videoUrl.split('/').pop().split('?')[0].split('.')[0];
  if (!videoId) return null;

  return `${prefix}${videoId}${suffix}`;
};

/**
 * Determines if a given file URL corresponds to a video file based on its extension.
 * @param {String} fileUrlRaw - the URL of the file to check
 * @returns {Object} - returns true if the file is a video based on its extension, false otherwise
 */
export const isVideo = (fileUrlRaw) => {
  const extensions = ['.mp4', '.ogv', '.ogg', '.avi', '.mov', '.m4p', '.m4v', '.mpg', '.mp2', '.mpeg', '.3gp', '.3g2'];
  const fileUrl = fileUrlRaw?.split('?')[0]; // ignore any query version parameter. i.e. https://cdn.shopify.com/s/files/filename.ext?v=70482359
  const extension = extensions.find((ext) => fileUrl?.toLowerCase().endsWith(ext));

  if (extension) {
    return { result: true, extension: extension.replace('.', '') };
  }

  return { result: false, extension: '' };
};

export const extraExtensions = ['.m3u8'];